__turbopack_context__.v({
  "footer": "ArticleFooter-module-scss-module__06uZQW__footer",
  "icon-container": "ArticleFooter-module-scss-module__06uZQW__icon-container",
  "scroll-to-top": "ArticleFooter-module-scss-module__06uZQW__scroll-to-top",
  "social-plug": "ArticleFooter-module-scss-module__06uZQW__social-plug",
});
